// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum EDITOR_EMBEDDING_TYPE {
    spotify = 'spotify',
    xTwitter = 'x-twitter',
    youtube = 'youtube',
    vimeo = 'vimeo',
}
